import React from 'react';

export const Gaming: React.FC = () => {
  return (
    <div className="min-h-screen cosmic-bg p-6">
      <div className="max-w-6xl mx-auto">
        
        {/* Header avec style cosmique */}
        <div className="cosmic-card p-8 mb-8 border border-emerald-800/30">
          <div className="flex items-center space-x-4 mb-6">
            <div className="w-16 h-16 rounded-full cosmic-glow bg-gradient-to-br from-emerald-600 to-cyan-600 flex items-center justify-center animate-float">
              <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z" />
              </svg>
            </div>
            <div>
              <h1 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 via-cyan-400 to-teal-400 neon-text mb-2">
                Gaming Zone
              </h1>
              <p className="text-emerald-200 text-lg">
                Découvrez et jouez aux projets web créés par la communauté Jupipotes
              </p>
            </div>
          </div>
        </div>

        {/* Coming Soon Section - Style cosmique */}
        <div className="cosmic-card p-12 border border-cyan-400/30 text-center animate-glow">
          <div className="mb-8 animate-pulse-slow">
            <svg className="w-32 h-32 mx-auto text-cyan-400 mb-6 animate-float" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z" />
            </svg>
            <div className="inline-block px-8 py-3 cosmic-glow bg-gradient-to-r from-emerald-600 to-cyan-600 rounded-full mb-6">
              <span className="text-2xl font-bold text-white neon-text tracking-wider">BIENTÔT DISPONIBLE</span>
            </div>
          </div>

          <h2 className="text-3xl font-bold text-cyan-300 mb-4 neon-text">
            La Gaming Zone arrive bientôt ! 🚀
          </h2>
          <p className="text-emerald-200 text-lg mb-8 max-w-2xl mx-auto">
            Nous préparons un espace incroyable où vous pourrez partager et jouer aux jeux web créés par la communauté. 
            Restez connectés pour la sortie !
          </p>

          <div className="flex items-center justify-center space-x-4 text-emerald-300">
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 rounded-full bg-cyan-400 animate-ping"></div>
              <span className="text-sm">En développement</span>
            </div>
          </div>
        </div>

        {/* Features à venir - Style cosmique */}
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="cosmic-card p-6 border border-emerald-800/30 cosmic-hover-effect">
            <div className="w-12 h-12 rounded-full bg-emerald-600/20 border border-emerald-400/30 flex items-center justify-center mb-4 cosmic-glow">
              <svg className="w-6 h-6 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-cyan-300 mb-2 neon-text">Upload de jeux</h3>
            <p className="text-emerald-200 text-sm">
              Partagez vos créations de jeux web en HTML5 avec toute la communauté
            </p>
          </div>

          <div className="cosmic-card p-6 border border-emerald-800/30 cosmic-hover-effect">
            <div className="w-12 h-12 rounded-full bg-cyan-600/20 border border-cyan-400/30 flex items-center justify-center mb-4 cosmic-glow">
              <svg className="w-6 h-6 text-cyan-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-cyan-300 mb-2 neon-text">Jouer en ligne</h3>
            <p className="text-emerald-200 text-sm">
              Jouez directement dans votre navigateur sans téléchargement
            </p>
          </div>

          <div className="cosmic-card p-6 border border-emerald-800/30 cosmic-hover-effect">
            <div className="w-12 h-12 rounded-full bg-teal-600/20 border border-teal-400/30 flex items-center justify-center mb-4 cosmic-glow">
              <svg className="w-6 h-6 text-teal-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-cyan-300 mb-2 neon-text">Votes & Likes</h3>
            <p className="text-emerald-200 text-sm">
              Votez pour vos jeux préférés et découvrez les meilleurs hits de la communauté
            </p>
          </div>
        </div>

        {/* Info technique - Style cosmique */}
        <div className="mt-8 cosmic-card p-6 border border-emerald-800/30">
          <h3 className="text-xl font-bold text-cyan-300 mb-4 neon-text">
            💡 Préparez votre jeu web
          </h3>
          <div className="space-y-3 text-emerald-200">
            <div className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-6 h-6 rounded-full bg-cyan-600/20 border border-cyan-400/30 flex items-center justify-center text-cyan-300 text-sm font-bold cosmic-glow">1</span>
              <p className="text-sm">Exportez votre jeu en HTML5 depuis votre moteur de jeu favori</p>
            </div>
            <div className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-6 h-6 rounded-full bg-cyan-600/20 border border-cyan-400/30 flex items-center justify-center text-cyan-300 text-sm font-bold cosmic-glow">2</span>
              <p className="text-sm">Préparez vos fichiers <span className="text-cyan-300 font-mono">.html, .js</span> et assets</p>
            </div>
            <div className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-6 h-6 rounded-full bg-cyan-600/20 border border-cyan-400/30 flex items-center justify-center text-cyan-300 text-sm font-bold cosmic-glow">3</span>
              <p className="text-sm">Préparez vos fichiers pour l'upload quand la fonctionnalité sera disponible ! 🎮</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
